import React, { useState, useEffect } from 'react';
import { StyledLineHeader } from './styled';
import { Segmented } from 'antd';
import Line from './Chart';
import { getLineData } from './utils';

const LinePanel = ({ data }) => {
  const [selected, setSelected] = useState<string>('kpiSampleSize');
  const [sankeyData, setSankeyData] = useState({
    series: [],
    categories: [],
    dates: [],
  });

  useEffect(() => {
    const lineData = getLineData(data, selected);
    setSankeyData(lineData);
  }, [data, selected]);

  return (
    <>
      <StyledLineHeader>
        <h3>CDN Resources & ISP - Impact Avoidance Breakdown</h3>
        <Segmented
          defaultValue={selected}
          options={[
            {
              label: 'KPI Sample Size',
              value: 'kpiSampleSize',
            },
            {
              label: 'Duration',
              value: 'duration',
            },
          ]}
          onChange={(value) => {
            setSelected(String(value));
          }}
        />
      </StyledLineHeader>
      <Line data={sankeyData} type={selected} />
    </>
  );
};

export default React.memo(LinePanel);
